// ======================================================================
// File Name       : SuperuserTopNavigatorConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as FUNCTION from './FunctionConstants';
import * as Path from './PathConstants';
import * as ICON from './IconConstants';
import { IS_SHOW_MENU_DEVELOP_FEATURE_51, IS_SHOW_MENU_DEVELOP_FEATURE_53_PHASE_2 } from './index';

const SUPER_TOP_NAVIGATOR_CONFIG = [
  {
    title: "システム",
    id: "G_SYSTEM",
    id: FUNCTION.G_SYSTEM,
    line: true,
    child: [
      {
        title: "サービス一覧",
        path: Path.SERVICE_LIST,
        id: FUNCTION.SERVICE_LIST,
        icon: ICON.FLAG,
      },
      {
        title: "サービスグループ",
        path: Path.SERVICE_GROUP_LIST,
        id: FUNCTION.SERVICE_GROUP_LIST,
        icon: ICON.SERVICE_GROUP,
      },
      {
        title: "企業情報",
        path: Path.ENTERPRISE_LIST,
        id: FUNCTION.ENTERPRISE_LIST,
        icon: ICON.COMPANY,
      },
      {
        title: "管理ユーザー",
        path: Path.SUPERUSER_LIST,
        id: FUNCTION.SUPERUSER_LIST,
        icon: ICON.USER,
      },
      {
        title: "ロールと権限",
        path: Path.SUPERUSER_ENTERPRISE_ROLE_LIST,
        id: FUNCTION.SUPERUSER_ENTERPRISE_ROLE_LIST,
        icon: ICON.ROLE,
      },
    ],
  },
  {
    title: "アカウント管理",
    path: Path.ACCOUNT_EDIT,
    id: FUNCTION.ACCOUNT_EDIT,
    icon: ICON.KEY,
  },
  {
    title: "企業切り替え",
    path: Path.ENTERPRISE_SWITCHING,
    id: FUNCTION.ENTERPRISE_SWITCHING,
    icon: ICON.ENTERPRISE_SWITCHING,
  },
  {
    title: '問い合わせ',
    id: FUNCTION.CONTACT,
    icon: ICON.CONTACT,
  },
  {
    title: 'マニュアル',
    id: FUNCTION.FAQ,
    icon: ICON.FAQ,
  },
  {
    title: "ログアウト",
    id: FUNCTION.LOGOUT,
    icon: ICON.LOGOUT,
  },
];

export default SUPER_TOP_NAVIGATOR_CONFIG;
